import { Builder } from "flatbuffers";
import { vec3 } from "gl-matrix";
import { TrackingBatPositionWire } from "../../../flatbuffers/mannequin";
import { vec3FromFlatBuffer, vec3ToFlatBuffer } from "../../../../util/gl-matrix/misc";

export interface TrackingBatPosition {
  headPosition: vec3;
  handlePosition: vec3;
}

export class TrackingBatPositionSerializer {
  static serializeBinary(position: TrackingBatPosition, builder: Builder): number | undefined {
    TrackingBatPositionWire.startTrackingBatPositionWire(builder);

    TrackingBatPositionWire.addHeadPosition(builder,  vec3ToFlatBuffer(position.headPosition, builder));
    TrackingBatPositionWire.addHandlePosition(builder, vec3ToFlatBuffer(position.handlePosition, builder));

    return TrackingBatPositionWire.endTrackingBatPositionWire(builder);
  }

  static deserializeBinary(posWire?: TrackingBatPositionWire): TrackingBatPosition | undefined {
    if (!posWire) return undefined;

    const headPosition = posWire.headPosition();
    const handlePosition = posWire.handlePosition();

    if (!headPosition || !handlePosition) {
      console.error("invalid bat position");
      return undefined;
    }

    return {
      headPosition: vec3FromFlatBuffer(headPosition),
      handlePosition: vec3FromFlatBuffer(handlePosition),
    }
  }
}
